import React from 'react'
import { Button, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import * as firebase from 'firebase'
import '../App.css'
import FirebaseStateComponent from '../common/FirebaseStateComponent.js'
import Spinner from '../common/Spinner.js'
import User from '../common/User.js'

export default class SearchPage extends FirebaseStateComponent {
  constructor (props) {
    super(props)

    this.sid = null
    this.tasksRef = null
    this.resultsRef = null

    // Start with empty value and suggestions
    this.state = {
      query: '',
      searchButtonEnabled: false,
      searching: false,
      loading: true,
      results: [],
      friends: {}
    }

    // Add friends binding
    this.handleProps(props, false)
  }

  componentWillReceiveProps (nextProps) {
    super.componentWillReceiveProps()

    // Process new props
    this.handleProps(nextProps)
  }

  handleProps (props, checkPrevious = true) {
    // Check if the new props contain the 'uid' value
    if (props.hasOwnProperty('uid') && props.uid) {
      // Check if the value has changed
      if (!checkPrevious || !this.props.hasOwnProperty('uid') || this.props.uid !== props.uid) {
        // Store the search results ref
        this.resultsRef = firebase.database().ref().child('search/results/' + this.props.uid)

        // Add user binding
        this.addBinding('friends', 'friends/' + props.uid)
      }
    } else {
      // No new 'uid' value, remove user binding
      this.removeBinding('friends')

      // Reset the search results ref
      this.resultsRef = null
    }
  }

  didUpdateStateValueForKey(stateKey) {
    if (stateKey === 'results') {
      if (this.state[stateKey] || this.state[stateKey] === false) {
        this.setState({
          searching: false
        })
      }
    }
  }

  getRenderedSearchResults () {
    const query = this.state.query

    if (query === null || query.length === 0 || this.sid === null) {
      return <div />
    } else {
      const searching = this.state.searching

      if (searching) {
        return <Spinner />
      } else {
        const results = this.state.results

        if (!results || results.length === 0) {
          return <div>No results</div>
        } else {
          const friends = this.state.friends
          const self = this
          const users = results.map(function (user, i) {
            const isYou = (user.uid === self.props.uid)
            const isFriend = (friends && friends[user.uid] === true)
            return <User uid={user.uid} you={isYou} friend={isFriend} onAdd={self.createAddFriendTask} padding={true} key={i} />
          })
          return <div className='search-result'>{users}</div>
        }
      }
    }
  }

  render () {
    if (this.state.loading) {
      return <Spinner />
    } else {
      const searchResults = this.getRenderedSearchResults()

      return (
        <div className='SearchPage'>
          <h2>Search</h2>
          <ControlLabel>Search query:</ControlLabel>
          <Form inline={true} style={{marginBottom: '10px'}}>
            <FormGroup controlId="searchQuery">
              <FormControl type='text' value={this.state.query} disabled={this.state.searching} onChange={this.searchQueryChanged} />
            </FormGroup>
            {' '}
            <Button type="submit" disabled={this.state.searching || !this.state.searchButtonEnabled} onClick={this.searchButtonClicked}>
              Search
            </Button>
          </Form>
          {searchResults}
        </div>
      )
    }
  }

  searchQueryChanged = (event) => {
    // Clear previous search key and all previous results
    this.sid = null
    this.resultsRef.set(null)
    this.removeBinding('results', [])

    // Get the seach query and store in state, disable/enable search button
    const query = event.target.value
    this.setState({
      query: query,
      searchButtonEnabled: (query.length > 0)
    })
  }

  searchButtonClicked = (event) => {
    event.preventDefault()

    // Show spinner
    this.setState({
      searching: true
    }, function () {
      // Create search task
      this.createSearchTask(this.state.query)
    })
  }

  createSearchTask = (query) => {
    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === null) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new search task on the queue
    this.sid = this.tasksRef.push({
      task: 'search_users',
      uid: this.props.uid,
      query: query
    }).key

    console.log('Created search task ' + this.sid + ' for query: ' + this.state.query)

    // Listen for results
    this.addBinding('results', 'search/results/' + this.props.uid + '/' + this.sid)
  }

  createAddFriendTask = (friendUid) => {
    console.log('Creating add_friend task with friendUid: ' + friendUid)

    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === null) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new add_friend task on the queue
    this.tasksRef.push({
      task: 'add_friend',
      uid: this.props.uid,
      friendUid: friendUid
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/Search.js